/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Dialog, AppBar, Toolbar, Slide, IconButton, Typography, Paper, CircularProgress, Button, List, ListItem, ListItemText, Divider } from '@material-ui/core'
import { Close, Add } from '@material-ui/icons'

import Policy from './components/Policy';

import Actions from '../../../fluid/Actions/ActionFactory'
import Action from '../../../fluid/Actions/ActionFactory';
import { allowedByOpop } from '../../Security/SecureCheck'

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  }
})

class PolicyEditor extends Component {
    state = {
      policies : [],
      temp_policies : [],
      loading_policies : false,
      err_loading_policies : false,
      error: false,
      error_message : null,
      adding_policy : false,
      selected_policy_name : null,
      selected_policy : null,
      editing_policy : false
    }

    generateNewPolicyObject = () => {
      let role_data = {
        group_name : this.props.roleData.group_name,
        name : this.props.roleData.name
      }
      return {
        name : "",
        description : "",
        roles : [role_data],
        assets : [],
        privileges : []
      }
    }

    componentDidMount () {
      // this.setState({...this.state, loading_policies : true})
      this.getPolicies()
    }

    getPolicies = (chained_func) => {
      this.setState({...this.state, loading_policies : true, err_loading_policies : false, policies : [], temp_policies: []}, () => {
        Actions('http_request', {
          url : "/sainapse/policy/role/" + this.props.roleData.name + "/group/" + this.props.roleData.group_name,
          method : "get",
          data : {}
        }).then(res => {
          this.setState({...this.state, loading_policies : false, policies : res.data.result, temp_policies : res.data.result}, () => {
            if (chained_func) {
              chained_func()
            }
          })
        }).catch(err => {
          this.setState({...this.state, policies: [], temp_policies : [], loading_policies : false, err_loading_policies : true })
        })
      })  
    }

    togglePolicy = (policy) => {
      if (this.state.selected_policy !== null) {
        if (this.state.selected_policy.name === policy.name) {
          this.setState({...this.state, selected_policy : null, selected_policy_name : null})
        } else {
          this.setState({...this.state, selected_policy : policy, selected_policy_name : policy.name})
        }
      } else {
        this.setState({...this.state, selected_policy : policy, selected_policy_name : policy.name})
      }
    }

    renderPolicyList = () => {
      return (
        <div
          style = {{width : '25%', height : '100%', borderRight : '1px solid rgba(0,0,0,0.12)', backgroundColor : '#FFFFFF'}}
        >
          <Paper
            square
            style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}
          >
            <Typography style = {{flexGrow: 1}} variant = 'button'>Applied Policies</Typography>
            {!this.state.loading_policies && !this.state.adding_policy && 
            <Button
              variant = 'outlined'
              color = "primary"
              startIcon = {<Add/>}
              onClick = {() => this.setState({...this.state, adding_policy : true, selected_policy_name : null, selected_policy : this.generateNewPolicyObject(), editing_policy : true}, () => console.log("Policy New State : ", this.state))}
              disabled = {!allowedByOpop({
                operation : "/sainapse/policy",
                method : "POST",
                operands : []
                })}
            >Add Policy</Button>}
          </Paper>
          <div style = {{width : '100%', maxHeight : 'calc(100vh - 100px)', overflow : 'auto'}}>
            <List>
              {this.state.policies.map((policy) => {
                return (
                  <Fragment>
                    <ListItem 
                      button 
                      selected = {this.state.selected_policy !== null && this.state.selected_policy.name === policy.name}
                      onClick = {() => this.togglePolicy(policy)}
                    >
                      <ListItemText>{policy.name}</ListItemText>
                    </ListItem>
                    <Divider/>
                  </Fragment>
                )
              })}
            </List>
          </div>
        </div>
      )
    }

    renderPolicyDetail = () => {
      if (this.state.selected_policy) {
        return (
          <div
            style = {{flexGrow : 1, height : 'calc(100vh - 50px)', padding : '10px'}}
          >
              <Policy
                id = {this.state.selected_policy.name}
                policy = {this.state.selected_policy} 
                edit = {this.state.editing_policy}
                new_policy = {this.state.adding_policy}
                toggle_edit_policy = {(edit) => {
                  this.setState({
                    ...this.state, 
                    editing_policy : edit,
                    adding_policy : false,
                    selected_policy : this.state.adding_policy ? null : this.state.selected_policy
                  })
                }}
                create_new_policy = {(policy) => this.createNewPolicy(policy)}
                update_policy = {(policy) => this.updatePolicy(policy)} 
                submit_policy = {(type, policy) => this.submitPolicy(type, policy)}
                delete_policy = {(policy) => this.deletePolicy(policy)}
                error = {this.state.error}
                error_message = {this.state.error_message}
                handleErrorClose = {() => {this.setState({...this.state, error: false, error_message: null })}}
              />
          </div>
        )
      }
    }

    createNewPolicy = (policy) => {

    }

    deletePolicy = (policy) => {
      Action('http_request', {
        url : "/sainapse/policy/" + policy.name,
        method: "delete",
        data : {}
      }).then(res => {
        this.getPolicies(() => {
          this.setState({
            ...this.state, 
            editing_policy : false, 
            selected_policy : null, 
            adding_policy : false 
          })
        })
      }).catch(err => {

      })
    }

    updatePolicy = (policy) => {
      this.setState({...this.state, selected_policy : policy})
    }

    submitPolicy = (type, policy) => {
      console.log("Submitting Policy Type : ", type)
      console.log("Submitting Policy : ", policy)
      if (type === 'new') {
        Actions('http_request', {
          url : "/sainapse/policy",
          method : 'post',
          data : policy
        }).then(res => {
          this.getPolicies(() => {
            this.setState({...this.state, editing_policy : false, selected_policy : policy, adding_policy : false })
          })
        }).catch(err => {
          this.setState({...this.state, err_loading_policies : true, error: true, error_message: err})
        })
      } else if (type === 'update') {
        Actions('http_request', {
          url : "/sainapse/policy/" + policy.name,
          method : 'put',
          data : policy
        }).then(res => {
          this.getPolicies(() => {
            this.setState({...this.state, editing_policy : false, selected_policy : policy, adding_policy : false })
          })
        }).catch(err => {
          this.setState({...this.state, err_loading_policies : true, error: true, error_message: err })
        })
      }
    }

    render() { 
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
              <Dialog
                fullScreen
                open = {this.props.open}
                onClose = {this.props.onClose}
                TransitionComponent={Transition}
                TransitionProps = {{open : this.props.open}}
              >
                <AppBar
                  className={classes.appBar}
                  // color = "transparent"
                >
                  <Toolbar variant="dense">
                    {this.state.loading_policies && <CircularProgress size = {20} variant = 'indeterminate' color = "inherit"/>}
                    <Typography variant="h6" className={classes.title}>
                      {this.state.loading_policies ? "Loading ..." : this.props.roleData.group_name + " / " + this.props.roleData.name}
                    </Typography>
                    <IconButton size = 'small' edge="end" color="inherit" onClick={this.props.onClose} aria-label="close">
                      <Close />
                    </IconButton>
                  </Toolbar>
                </AppBar>
                <div
                  style = {{width : '100%', height : 'calc(100vh - 50px)', backgroundColor: '#F0F0F0',  display : 'flex', flexDirection : 'row'}}
                >
                  {this.renderPolicyList()}
                  {this.renderPolicyDetail()}
                </div>
              </Dialog>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(PolicyEditor);